import { useRef, useEffect } from 'react';
import pluralize from 'pluralize';

/* Utils used by multiple roles */
const sortAlphabetical = (arr, key) => {
  return arr.sort((a, b) => a[key].localeCompare(b[key]));
};

const asyncFlush = () => new Promise(resolve => setTimeout(resolve, 0));

const deepUpdate = async wrapper => {
  await asyncFlush();
  await wrapper.update();
};

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

const buildQueryFilter = filters => {
  const filterString = filters
    .map(filter => {
      const { field, operation, value } = filter;
      if (!value) return null;

      return `${encodeURI(field)}|${encodeURI(operation)}|${encodeURI(value)}`;
    })
    .filter(filter => !!filter)
    .join(';');
  return filterString || null;
};

const buildCountDescription = (count, entityName, dropdownFields) => {
  if (typeof count === 'undefined' || count === null) {
    return null;
  }

  const allModifier = dropdownFields.length || count <= 1 ? '' : 'All';
  const andedFields = joinArrayWithAnd(dropdownFields.map(field => field.label));
  const pluralizeModifier = pluralize(entityName, count);

  return `${allModifier} ${count.toString()} ${andedFields} ${pluralizeModifier}`;
};

// Niche util function that joins array values into a string while prepending the final value with 'And'
const joinArrayWithAnd = inputArray => {
  if (!inputArray.length) return '';

  if (inputArray.length === 1) {
    return inputArray[0];
  }

  const finalValue = inputArray.pop();
  return `${inputArray.join(', ')} and ${finalValue}`;
};

export {
  asyncFlush,
  sortAlphabetical,
  deepUpdate,
  usePrevious,
  buildQueryFilter,
  buildCountDescription,
  joinArrayWithAnd,
};
